import apiClient from 'services/api';
import { lerRefreshToken, limparSessao } from 'services/sessao';
import { encerrarPush } from 'services/pushNotificacoes';

/**
 * Sair da conta, dos dois lados.
 *
 * <h2>Por que nao basta apagar do navegador</h2>
 * Ate a v1.11.3 o logout era so `localStorage.removeItem`. Aquilo bastava enquanto a sessao era um
 * JWT sozinho -- some do aparelho, e o token seguia valido no servidor ate expirar, mas ninguem
 * mais o tinha. Com o refresh token isso deixou de bastar: ele vale 30 DIAS, e uma copia (feita
 * antes do logout, num aparelho compartilhado, ou por quem tivesse lido o armazenamento) continuaria
 * renovando a sessao indefinidamente depois de a pessoa ter saido.
 *
 * O `POST /login/logout` revoga os refresh tokens da pessoa no banco -- todos, em qualquer aparelho,
 * porque e isso que "sair" significa para quem aperta o botao.
 *
 * <h2>A limpeza local acontece de qualquer jeito</h2>
 * A chamada e aguardada, mas a falha dela e engolida: sem rede, ou com o backend fora do ar, a
 * pessoa ainda tem que conseguir sair da conta neste aparelho. Travar o logout porque o servidor
 * nao respondeu seria prender alguem numa sessao que ela pediu para encerrar -- justamente o oposto
 * do que o botao promete.
 *
 * A consequencia de engolir: o refresh continua valido no servidor ate expirar. E o mesmo risco que
 * existia antes deste endpoint, e so no caso em que a chamada falha.
 *
 * <h2>A ordem importa: limpar PRIMEIRO, revogar depois</h2>
 * A limpeza ficava no fim, depois do `await`. Como quem chama nao espera esta funcao (o NavBar
 * navega no mesmo clique, de proposito -- ver a nota la), havia uma janela de uma ida ao servidor em
 * que a sessao ja tinha sido encerrada para a pessoa mas o token ainda estava no localStorage. No
 * app isso apareceu inteiro: o botao Sair caia no painel, montado com dados de uma conta que acabara
 * de sair, porque a raiz le `temSessao()` de forma sincrona para decidir entre login e dashboard.
 *
 * Inverter e seguro porque o /login/logout nao depende do que foi apagado: ele e permitAll (ver
 * PUBLIC_ENDPOINTS no SecurityConfig), revoga pelo refresh token que vai no CORPO -- capturado aqui
 * antes da limpeza -- e responde 204 mesmo sem Authorization. O que a requisicao perde ao sair sem o
 * Bearer e um header que o endpoint nunca leu.
 *
 * "Sair" e local e imediato; revogar no servidor e o esforco que se faz em seguida.
 */
export async function encerrarSessao() {
	const refreshToken = lerRefreshToken();

	limparSessao();
	// Sem await, como a revogação: o token sai do Firebase em paralelo. O backend apaga os aparelhos
	// da pessoa no /login/logout abaixo (RefreshTokenService) -- não há chamada própria aqui porque o
	// JWT acabou de ser apagado.
	encerrarPush();

	if (refreshToken) {
		try {
			await apiClient.post('/login/logout', { refreshToken });
		} catch {
			// Ver a nota acima: a sessao local ja caiu, e nada aqui a traz de volta.
		}
	}
}
